/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanBaseResponse } from '../models/boolean-base-response';

@Injectable({
  providedIn: 'root',
})
export class MailchimpService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiMailchimpPingGet
   */
  static readonly ApiMailchimpPingGetPath = '/api/Mailchimp/ping';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMailchimpPingGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMailchimpPingGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MailchimpService.ApiMailchimpPingGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiMailchimpPingGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMailchimpPingGet$Plain(params?: {
  }): Observable<BooleanBaseResponse> {

    return this.apiMailchimpPingGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMailchimpPingGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMailchimpPingGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MailchimpService.ApiMailchimpPingGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiMailchimpPingGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMailchimpPingGet$Json(params?: {
  }): Observable<BooleanBaseResponse> {

    return this.apiMailchimpPingGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiMailchimpAddMemberPost
   */
  static readonly ApiMailchimpAddMemberPostPath = '/api/Mailchimp/add-member';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMailchimpAddMemberPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMailchimpAddMemberPost$Plain$Response(params?: {
    email?: string;
    firstName?: string;
    lastName?: string;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MailchimpService.ApiMailchimpAddMemberPostPath, 'post');
    if (params) {
      rb.query('email', params.email, {});
      rb.query('firstName', params.firstName, {});
      rb.query('lastName', params.lastName, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiMailchimpAddMemberPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMailchimpAddMemberPost$Plain(params?: {
    email?: string;
    firstName?: string;
    lastName?: string;
  }): Observable<BooleanBaseResponse> {

    return this.apiMailchimpAddMemberPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMailchimpAddMemberPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMailchimpAddMemberPost$Json$Response(params?: {
    email?: string;
    firstName?: string;
    lastName?: string;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MailchimpService.ApiMailchimpAddMemberPostPath, 'post');
    if (params) {
      rb.query('email', params.email, {});
      rb.query('firstName', params.firstName, {});
      rb.query('lastName', params.lastName, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiMailchimpAddMemberPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMailchimpAddMemberPost$Json(params?: {
    email?: string;
    firstName?: string;
    lastName?: string;
  }): Observable<BooleanBaseResponse> {

    return this.apiMailchimpAddMemberPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

}
